<div id="otherTab" class="tab flex flex-col gap-medpace">
    <medpace-needs-travel-radio-group
        [label]="'Will the patient need other accommodations?'"
        [isDisabled]="false"
        [isUpdate]="isUpdate()"
        [formCtrl]="formGroup().controls.needsTravel"
    />
    @if (formGroup().controls.needsTravel.value) {
        <medpace-other-request-details
            [mode]="mode()"
            [formGroup]="formGroup().controls.travel.controls.requestDetails"
        />
    }
</div>
